module.exports = __webpack_public_path__ + "img/2022_09_dandelion_kamigamoshrine_fin_web.c05109ff.png";